export default import.meta.ROLLDOWN_FILE_URL_xTPV$_Jsulbg4jHfVf9Bng